import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import LazyPage from "./LazyPage";

const HomePage = lazy(() => import("@/pages/home/page"));
const AiFillPage = lazy(() => import("@/pages/ai-fill/page"));
const AiQaPage = lazy(() => import("@/pages/ai-qa/page"));
const UniversitiesPage = lazy(() => import("@/pages/data/universities/page"));
const MajorsPage = lazy(() => import("@/pages/data/majors/page"));
const ScoresPage = lazy(() => import("@/pages/data/scores/page"));
const PoliciesPage = lazy(() => import("@/pages/data/policies/page"));
const ProfilePage = lazy(() => import("@/pages/profile/page"));
const PlansPage = lazy(() => import("@/pages/profile/plans/page"));
const FavoritesPage = lazy(() => import("@/pages/profile/favorites/page"));
const MessagesPage = lazy(() => import("@/pages/profile/messages/page"));
const MembershipPage = lazy(() => import("@/pages/membership/page"));
const GaokaoNewsPage = lazy(() => import("@/pages/gaokao-news/page"));
const ScoreQueryPage = lazy(() => import("@/pages/score-query/page"));
const PreEnrollmentPage = lazy(() => import("@/pages/pre-enrollment/page"));
const HelpPage = lazy(() => import("@/pages/help/page"));
const DisclaimerPage = lazy(() => import("@/pages/disclaimer/page"));
const PrivacyPage = lazy(() => import("@/pages/privacy/page"));
const TermsPage = lazy(() => import("@/pages/terms/page"));
const PlanDetailPage = lazy(() => import("@/pages/plan-detail/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  { path: "/", element: <LazyPage component={HomePage} /> },
  { path: "/ai-fill", element: <LazyPage component={AiFillPage} /> },
  { path: "/ai-qa", element: <LazyPage component={AiQaPage} /> },
  { path: "/data/universities", element: <LazyPage component={UniversitiesPage} /> },
  { path: "/data/majors", element: <LazyPage component={MajorsPage} /> },
  { path: "/data/scores", element: <LazyPage component={ScoresPage} /> },
  { path: "/data/policies", element: <LazyPage component={PoliciesPage} /> },
  { path: "/profile", element: <LazyPage component={ProfilePage} /> },
  { path: "/profile/plans", element: <LazyPage component={PlansPage} /> },
  { path: "/profile/favorites", element: <LazyPage component={FavoritesPage} /> },
  { path: "/profile/messages", element: <LazyPage component={MessagesPage} /> },
  { path: "/membership", element: <LazyPage component={MembershipPage} /> },
  { path: "/gaokao-news", element: <LazyPage component={GaokaoNewsPage} /> },
  { path: "/score-query", element: <LazyPage component={ScoreQueryPage} /> },
  { path: "/pre-enrollment", element: <LazyPage component={PreEnrollmentPage} /> },
  { path: "/help", element: <LazyPage component={HelpPage} /> },
  { path: "/disclaimer", element: <LazyPage component={DisclaimerPage} /> },
  { path: "/privacy", element: <LazyPage component={PrivacyPage} /> },
  { path: "/terms", element: <LazyPage component={TermsPage} /> },
  { path: "/plan/:id", element: <LazyPage component={PlanDetailPage} /> },
  { path: "*", element: <LazyPage component={NotFound} /> },
];

export default routes;
